/**
 * The Apps tab's Quality: the release gate's rules (the Quality tab's, as on Home's "Ready to publish?"), failing
 * first, each with its own detail. The gate is the project's: the checks run across all its services, so the card
 * says so. "Open Quality" opens the full tab on this service.
 */
import React from 'react';
import PropTypes from 'prop-types';
import useQualityGate from '../../../hooks/useQualityGate';
import { gateRules } from '../../home/ReadyToPublish';
import { Card, OpenLink } from './common';

const MARKS = { pass: ['✓', 'is-pass'], fail: ['✕', 'is-fail'], unknown: ['○', 'is-unknown'] };

export default function QualityTab({ projectId, onOpen = null }) {
  const { gate, loading } = useQualityGate(projectId);
  const rules = gateRules(gate);
  const passing = rules.filter((rule) => rule.status === 'pass').length;
  return (
    <div className="apps-tab-body" data-testid="apps-tabpanel-quality">
      <Card testId="apps-quality-rules" title={rules.length ? `What blocks Publish · ${passing} of ${rules.length} pass` : 'What blocks Publish'} wide>
        {rules.length === 0 ? (
          <p className="apps-muted">{loading ? 'Reading the checks…' : 'No check has run yet. Run them in Quality to see what blocks Publish.'}</p>
        ) : (
          <>
            <ul className="apps-rules">
              {rules.map((rule) => {
                const [mark, tone] = MARKS[rule.status] || MARKS.unknown;
                return (
                  <li className={tone} data-testid={`apps-rule-${rule.id}`} key={rule.id}>
                    <span aria-hidden="true" className="apps-rule-mark">{mark}</span>
                    <span><span className="apps-row-name">{rule.label || rule.id}</span>{rule.detail && <span className="apps-muted apps-small"> {rule.detail}</span>}</span>
                  </li>
                );
              })}
            </ul>
            <p className="apps-muted apps-small">The checks cover the whole project, this service included.</p>
          </>
        )}
      </Card>
      <OpenLink label="Open Quality" onOpen={onOpen} testId="apps-open-quality" />
    </div>
  );
}

QualityTab.propTypes = { onOpen: PropTypes.func, projectId: PropTypes.string };
